import type { ContractSectionDef } from "./types";

/**
 * Section + step layout for the KFZ contract form.
 *
 * Reihenfolge:
 *  1. Allgemeine Informationen
 *     1.1 Kontakt + Vertragsart + Risikoauswahl (kombiniert)
 *  2. Risikoinformationen
 *     2.1 Erfasste Risikoinformationen (read-only)
 *  3. Vereinbarung mit dem Versicherer
 *  4. Versicherungsumfang
 *     4.1 Versicherungsumfang (per Klasse + per Risk für Rahmen-Tarife)
 *  5. Vertragsdaten und Zahlung
 *     5.1 Vertragsbeginn, Zahlweise, Bankverbindung
 */
export const KFZ_CONTRACT_SECTIONS: ContractSectionDef[] = [
  {
    key: "allgemein",
    title: "Allgemeine Informationen",
    color: "purple",
    steps: [
      {
        kind: "kontaktRisiko",
        key: "kontaktRisiko",
        title: "Kontakt & Risikoauswahl",
        description:
          "Wähle den Versicherungsnehmer und die zu versichernden Risikoobjekte.",
      },
      {
        kind: "vertragsBasis",
        key: "vertragsBasis",
        title: "Vertragsbasis",
        description:
          "Vorvertrag, Versicherer, Vertragsart und Tarifierung.",
      },
    ],
  },
  {
    key: "risiken",
    title: "Risikoinformationen",
    color: "orange",
    steps: [
      {
        kind: "risikoInfo",
        key: "risikoInfo",
        title: "Erfasste Risikoinformationen",
        description: "Aus den Risikoobjekten übernommene Stammdaten — nur zur Ansicht.",
      },
    ],
  },
  {
    key: "vereinbarung",
    title: "Vereinbarung mit dem Versicherer",
    color: "black",
    steps: [
      {
        kind: "vereinbarung",
        key: "vereinbarung",
        title: "Vereinbarung mit dem Versicherer",
        description:
          "Status der Vereinbarung zwischen Courté und dem gewählten Versicherer für diese Produkt-/Tarifierungsart.",
      },
    ],
  },
  {
    key: "umfang",
    title: "Versicherungsumfang",
    color: "green",
    steps: [
      {
        kind: "gefahren",
        key: "umfang",
        title: "Versicherungsumfang",
        description:
          "KFZ-Haftpflicht-, Kasko- und Zusatzbausteine. Bei Rahmen-Verträgen pro Klasse und pro Risiko.",
      },
    ],
  },
  {
    key: "beitraege",
    title: "Vertragsdaten und Zahlung",
    color: "pillarOrange",
    steps: [
      {
        kind: "zahlung",
        key: "zahlung",
        title: "Vertragsdaten & Zahlung",
        description:
          "Versicherungsbeginn / -ablauf, Zahlweise, Bankverbindung und Bemerkungen.",
      },
    ],
  },
];
